import { render } from "./DeviceGroupAddModal.vue?vue&type=template&id=72b200c4"
import script from "./DeviceGroupAddModal.vue?vue&type=script&lang=js"
export * from "./DeviceGroupAddModal.vue?vue&type=script&lang=js"
script.render = render

export default script